import { Typography } from "@kelp-dao/kernel-design-system";
import usePrices from "@hooks/usePrices";
import { numberToCurrency } from "utils";
import { useAccount } from "wagmi";

type HoldingsProps = {
  balance: string;
  balanceEth?: string | number;
  symbol: string;
};

const HoldingsV2 = ({ balance, balanceEth, symbol }: HoldingsProps) => {
  const { isConnected } = useAccount();
  const { assets, isLoading: exchangePricesLoading } = usePrices();

  const renderEthFiat = () => {
    if (
      !balanceEth ||
      balanceEth === "-" ||
      exchangePricesLoading ||
      !assets?.ETH?.usd
    ) {
      return null;
    }
    const fiat = (Number(balanceEth) * assets?.ETH?.usd).toFixed(2);
    return `${numberToCurrency(balanceEth.toString())} ETH ($${numberToCurrency(
      fiat
    )})`;
  };

  return (
    <div className="flex flex-col w-full justify-center h-full">
      {!isConnected && (
        <Typography
          type="body"
          variant="xsmall"
          className="text-xs leading-[14.4px] font-normal mb-3 text-text-secondary"
        >
          Connect your wallet to view personalized holdings
        </Typography>
      )}
      <div className="bg-bg-primary rounded-2xl p-4 tablet:p-8 min-h-[180px] tablet:min-h-[220px] flex items-center justify-center w-full h-full">
        <div className="flex flex-col gap-2 tablet:gap-3 w-full items-center justify-center">
          <Typography
            type="body"
            variant="small"
            className="text-text-secondary font-semibold text-sm tablet:text-base"
          >
            My total holdings
          </Typography>
          <Typography
            type="heading"
            variant="large"
            className="text-text-primary font-bold text-[28px] md:text-[32px] lg:text-[40px]"
          >
            {balance} {symbol}
          </Typography>
          {symbol !== "sbUSD" && (
            <Typography
              type="body"
              variant="small"
              className="text-text-secondary font-normal text-sm tablet:text-base"
            >
              {renderEthFiat()}
            </Typography>
          )}
        </div>
      </div>
    </div>
  );
};

export default HoldingsV2;
